import { Button } from "antd";
import { Image, OverlayTrigger } from "react-bootstrap";
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import viewIcon from '../../assets/images/view-icon.svg'



const OptionsDropdown = ({ children, viewHandler, deleteHandler, editHandler, extra }) => {
    return (
        <OverlayTrigger
            trigger={"click"}
            placement="left"
            overlay={
                <div className="options-dropdown p-3">
                    {children && children}
                    {
                        !children &&
                        <>
                            {extra && extra}

                            {viewHandler && <div onClick={viewHandler} >
                                <Image src={viewIcon} className="edit-icon" /> View Details
                            </div>}
                            {editHandler && <div className="" onClick={editHandler}><Image src={editIcon} className="edit-icon" /> Edit</div>}
                            {deleteHandler && <div className="" onClick={deleteHandler}><Image src={deleteIcon} className="edit-icon" /> Delete</div>}
                        </>
                    }
                </div>
            }
            rootClose
            flip
        >
            <div className="pointer d-flex px-4">{threeDotsIcon}</div>
        </OverlayTrigger>
    );
}

export default OptionsDropdown;

// vertical three dots icon
const threeDotsIcon = (
    <svg width="4" height="16" viewBox="0 0 4 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="2" cy="2" r="2" fill="#4E4E4E" />
        <circle cx="2" cy="8" r="2" fill="#4E4E4E" />
        <circle cx="2" cy="14" r="2" fill="#4E4E4E" />
    </svg>
);